import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {aShowDialog} from '@modifi/plugin-dialogs'
import {withTranslation} from '@modifi/plugin-i18n'
import TransactionList from './TransactionList'
import {
  aFetchTransactions,
  selectTransactionsByKeyWindow,
  selectTransactionsIsKeyWindowLoading,
  selectRelevantFlag,
  aSetRelevantFlag,
} from '../../store'
import {withProgress} from '../../../../util'
import {withReadAuthorization} from '../../../../components/with-read-authorization'
import {TRANSACTION_LIST} from '../../../../constants/section'

const mapStateToProps = state => {
  const isRelevant = selectRelevantFlag(state)
  return {
    transactionList: selectTransactionsByKeyWindow(state, {isRelevant}),
    loading: selectTransactionsIsKeyWindowLoading(state, {isRelevant}),
    isRelevant: selectRelevantFlag(state),
  }
}
const mapDispatchToProps = {
  fetchTransactions: aFetchTransactions,
  showDialog: aShowDialog,
  setRelevantFlag: aSetRelevantFlag,
}

export default compose(
  withReadAuthorization(TRANSACTION_LIST),
  withProgress(1000),
  withTranslation('moneta'),
  connect(mapStateToProps, mapDispatchToProps)
)(TransactionList)
